import React, { useState, useEffect } from "react";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import NewReleasesOutlinedIcon from "@material-ui/icons/NewReleasesOutlined";
import styled, { css } from "react-emotion";
import QtyInput from "../../CartWebComponent/CartUtil/QtyInput";
import AdditionalOptionsItemsGroup from "./AdditionalOptionsItemsGroup";
import WebIcon from "../../../WebIcon";
import { toast } from "react-toastify";
const inlineBlock = css`
  display: inline-block;
`;

import {
  withRedux,
  priceToDollars,
  isMobileDevice,
  getSortedDataToDisplay,
} from "helpers";

const isMob = isMobileDevice();

const cancelIconContainer = css`
  padding-right: 12px;
  display: none;
  @media only screen and (min-width: 768px) {
    display: block;
  }
`;

const AddToCartButton = styled("button")`
  color: ${(props) => props.color};
  border: ${(props) => "1px " + props.color + " solid"};
  padding: 10px;
  width: ${(props) => (isMob ? "280px" : props.width * 0.9)};
  margin: auto;
  border-radius: 30px;
  margin-bottom: 5px;
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
  @media only screen and (min-width: 768px) {
    width: 450px;
  }
`;

const notifyImage = css`
  width: 75px;
`;

const WebButton = styled("button")`
  padding: 10px;
  width: 125px;
  border-radius: 4px;
  color: white;
  background: ${(props) => props.background};
  font-weight: bold;
  border: none;
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  cursor: pointer;
  font-size: 0.875rem;
`;
const productImage = css`
  opacity: 1;
  transition: opacity 0.75s ease;
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 250px;
  height: 231px;
  object-fit: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;

const priceLabel = css`
  font-size: 1.125rem;
  line-height: 1.4375rem;
  font-weight: 700;
  letter-spacing: 0.25px;
  height: 1.4375rem;
`;
const productImageNullModal = css`
  width: 150px;
  height: 131px;
  object-fit: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin-top: 40px;
`;

const row = css`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;
`;

const smallText = css`
  font-size: 9px;
  height: auto;
`;
const productPrice = css`
  padding-top: 0.2rem;
  font-size: 14px;
  font-weight: bold;
`;

const productName = css`
  height: ${isMob ? "auto" : "70px"};
  font-size: 1.125rem;
  line-height: 1.4375rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
  margin-top: 0.25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  letter-spacing: 0.25px;
`;

const showOnMobile = css`
  @media only screen and (min-width: 768px) {
    display: none;
  }
`;

const productTitle = css`
  padding-left: 12px;
  text-decoration: none;
  font-size: 0.875rem;
  color: black;
  text-align: left;
  @media only screen and (max-width: 768px) {
    padding-left: 0px;
  }
`;

const errorText = css`
  color: #f44336;
  margin: 0;
  font-size: 0.75rem;
  margin-top: 10px;
  text-align: left;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  line-height: 1.66;
  letter-spacing: 0.03333em;
  text-align: center;
  background-color: white;
`;

const productCartWrap = css`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
`;

const additionalItems = css`
  font-size: 0.875rem;
  line-height: 1rem;
  margin-bottom: 35px;
  color: #bbb;
  font-weight: normal;
  word-break: break-word;
`;

function ProductInfoModal(props) {
  const {
    storeItem,
    storeColor,
    cart,
    toggleProductInfoModal,
    setShow,
    editItem,
    editItemIdx,
    isAdmin,
  } = props;
  const {
    id: purchaseItemId,
    price: subtotal,
    title,
    maxPurchasesPerUser,
    totalPurchasesByUser,
    numberOfTotalPurchases,
    maxPurchasesTotal,
    additionalOptions,
  } = storeItem;

  const BASE_SUBTOTAL = subtotal;

  // console.log("RENDERED PRODUCT INFO MODAL");

  const [cartItem, setCartItem] = useState({
    purchaseItemId,
    quantity: 1,
    subtotal,
    additionalOptionSelections: [],
  });
  const [error, setError] = useState("");
  const [cartItemChanged, setCartItemChanged] = useState(false);

  useEffect(() => {
    setError("");
    calculateCartItemSubtotal();
  }, [cartItemChanged]);

  useEffect(() => {
    if (editItem) {
      setCartItem(editItem);
      toggleChanged();
    }
  }, []);

  // console.dir(cartItem);

  const getGroupFromStoreItem = (id) => {
    let result = null;
    getAdditionalOptionsGroups().forEach((group) => {
      if (group.id === id) {
        result = group;
      }
    });

    return result;
  };

  const goToCheckout = () => {
    props.actions.setTemplate(props.activeApp.id, null);
    // console.log("going to checkout");
    if (isAdmin) {
      props.history.push({
        pathname: `/${props.activeApp.landingPagePath}/home?isAdmin=true`,
        state: { path: "checkout" },
      });
      return;
    }
    props.history.push({
      pathname: `/${props.activeApp.landingPagePath}/home`,
      state: { path: "checkout" },
    });
  };

  const goToCart = () => {
    props.actions.setTemplate(props.activeApp.id, null);
    if (isAdmin) {
      props.history.push({
        pathname: `/${props.activeApp.landingPagePath}/home?isAdmin=true`,
        state: { path: "cart" },
      });
      return;
    }
    props.history.push({
      pathname: `/${props.activeApp.landingPagePath}/home`,
      state: { path: "cart" },
    });
  };

  const getItemPriceFromGroup = (group, itemId) => {
    let price = null;

    group.additionalOptionsItems.forEach((item) => {
      if (item.id === itemId) {
        price = item.price;
      }
    });

    return price;
  };

  const calculateCartItemSubtotal = () => {
    // console.log("calculating new cart item subtotal...");

    const { additionalOptionSelections } = cartItem;
    const tempCartItem = { ...cartItem, subtotal: BASE_SUBTOTAL };

    additionalOptionSelections.forEach((group) => {
      const storeItemGroup = getGroupFromStoreItem(
        group.additionalOptionsGroupId
      );
      if (storeItemGroup != null) {
        group.additionalOptionItemSelections.forEach((item) => {
          // console.dir(item);
          const itemPrice = getItemPriceFromGroup(
            storeItemGroup,
            item.selectedAdditionalItemId
          );
          if (itemPrice != null) tempCartItem.subtotal += itemPrice;
        });
      }
    });

    tempCartItem.subtotal *= tempCartItem.quantity;

    setCartItem(tempCartItem);
  };

  const toggleChanged = () => {
    setCartItemChanged(!cartItemChanged);
  };

  function handleCartItemChange(cartItem) {
    setCartItem(cartItem);
    toggleChanged();
  }

  const selectionIsRequired = (group) => {
    return !group.isOptional;
  };

  const isEmpty = (obj) => {
    return Object.keys(obj).length === 0;
  };

  const allSelectionsAreValid = () => {
    const { additionalOptionSelections } = cartItem;
    const { additionalOptions } = storeItem;

    const requiredGroups = {};
    getAdditionalOptionsGroups().map((group) => {
      if (selectionIsRequired(group)) {
        requiredGroups[group.id] = group.title;
      }
    });

    // if there are no required groups
    if (isEmpty(requiredGroups)) return true;

    additionalOptionSelections.forEach((group) => {
      // console.log(
      //   "validating group with id: " + group.additionalOptionsGroupId
      // );
      if (requiredGroups[group.additionalOptionsGroupId]) {
        // console.log("group is validated.");
        delete requiredGroups[group.additionalOptionsGroupId];
      }
    });

    if (!isEmpty(requiredGroups)) {
      const string = `A selection is required for group(s): ${Object.values(
        requiredGroups
      ).join(", ")}.`;
      setError(string);
      window.setTimeout(() => {
        setError("");
      }, 2000);
    }

    return isEmpty(requiredGroups);
  };

  const getItemNameFromGroup = (group, itemId) => {
    let name = null;

    group.additionalOptionsItems.forEach((item) => {
      if (item.id === itemId) {
        name = item.name;
      }
    });

    return name;
  };

  const renderAdditionalItems = (cartItem, storeItem) => {
    const items = {};
    // console.log("rendering addtional items...");
    // console.dir(cartItem);
    cartItem.additionalOptionSelections.forEach((group) => {
      const storeItemGroup = getGroupFromStoreItem(
        group.additionalOptionsGroupId,
        storeItem
      );
      items[storeItemGroup.title] = [];
      if (storeItemGroup != null) {
        group.additionalOptionItemSelections.forEach((item) => {
          const itemName = getItemNameFromGroup(
            storeItemGroup,
            item.selectedAdditionalItemId
          );

          items[storeItemGroup.title].push(itemName);
        });
      }
    });

    const strings = [];

    Object.keys(items).forEach(function eachKey(key) {
      const string = `${key}: ${items[key].join(", ")}`;
      strings.push(string);
    });

    return (
      <div style={{ marginBottom: "10px" }}>
        {strings.map((string) => {
          return (
            <span className={additionalItems}>
              {string}
              <br />
            </span>
          );
        })}
      </div>
    );
  };

  const Msg = (props) => {
    // console.log(props.text);
    const { title, price, imageUrl } = storeItem;
    const { cartQty } = cart;
    return (
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "15px",
          }}
        >
          <div style={{ marginRight: "10px" }}>
            {" "}
            <WebIcon
              iconName={"checkMark"}
              useColor={true}
              size={"12px"}
              hover={false}
              className={inlineBlock}
              customColor={"#4caf50"}
            />
          </div>
          <p>Added to Cart</p>
        </div>

        <div className={productCartWrap}>
          {imageUrl ? (
            <div style={{ width: "50%", textAlign: "center" }}>
              <img src={imageUrl} className={notifyImage} />
            </div>
          ) : null}

          <div
            className={productTitle}
            style={{ marginBottom: "10px", width: "50%" }}
          >
            {" "}
            <p style={{ marginBottom: "10px" }}>{title}</p>
            {/* <EditButton
              color={props.activeApp.view.navigation.navBarColor}
              onClick={() => toggleEditItem(cartItem, productFromStore, index)}
            >
              Edit
            </EditButton> */}
            {renderAdditionalItems(cartItem, storeItem)}
            <p>{priceToDollars(cartItem.subtotal)}</p>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            marginTop: "15px",
          }}
        >
          <WebButton
            onClick={goToCart}
            background={storeColor}
            style={{ marginRight: "20px" }}
          >
            View Cart ({cartQty + cartItem.quantity})
          </WebButton>
          <WebButton onClick={goToCheckout} background={storeColor}>
            Checkout
          </WebButton>
        </div>
      </div>
    );
  };

  const notify = (action) => {
    // console.log("rendering a toast");
    switch (action) {
      case "add":
        toast(Msg({ text: storeItem.title + " has been added to cart!" }), {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 4000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
        break;
      default:
        return null;
    }
  };

  const handleAddToCart = () => {
    // console.log("Adding " + title + " to cart");
    // console.log("cartItemObject");
    // console.dir(cartItem);
    setError("");
    // TODO: check if all required groups were selected
    if (allSelectionsAreValid()) {
      if (editItem) {
        // console.log("updating cart item");
        props.actions.updateItemInCart(cartItem, editItemIdx, editItem);
      } else {
        props.actions.addToCart(cartItem);
        notify("add");
      }

      setShow(true);
      window.setTimeout(() => {
        setShow(false);
      }, 2000);
      // console.log("SUCCESS!");
      // console.dir(props.cart);
      toggleProductInfoModal();
    }
  };

  const getNumItemsAlreadyInCart = () => {
    const { cartItems } = cart;
    const items = cartItems.filter(
      (item) => item.purchaseItemId === purchaseItemId
    );
    let numItemsAlreadyInCart = 0;
    items.forEach((item) => {
      numItemsAlreadyInCart += item.quantity;
    });
    return numItemsAlreadyInCart;
  };

  const getRemainingPurchaseInfo = (numOfItemsAlreadyInCart) => {
    // console.log("calculating remaining purchase info for: " + title);
    let purchasesRemaining = null;
    let maxPurchasesReached = false;
    let soldOut = false;

    // because items might already be in cart, we should could those as "purchased"
    let totalEffectivePurchasesByUser =
      (totalPurchasesByUser ? totalPurchasesByUser : 0) +
      numOfItemsAlreadyInCart;

    // check if each user is limited to an amount
    if (maxPurchasesPerUser != null && maxPurchasesPerUser > 0) {
      // check if user has hit max
      if (totalEffectivePurchasesByUser >= maxPurchasesPerUser) {
        maxPurchasesReached = true;
        purchasesRemaining = 0;
      } else {
        // calculate how many purchases user has remaining
        purchasesRemaining =
          maxPurchasesPerUser - totalEffectivePurchasesByUser;
      }
    }

    let effectiveCurrentTotalPurchases =
      (numberOfTotalPurchases ? numberOfTotalPurchases : 0) +
      numOfItemsAlreadyInCart;

    if (maxPurchasesTotal != null) {
      // there is a max number of total purchases for this - display accordingly
      if (effectiveCurrentTotalPurchases >= maxPurchasesTotal) {
        maxPurchasesReached = true;
        soldOut = true;
      } else {
        let purchasesUntilMaxAllowed =
          maxPurchasesTotal - effectiveCurrentTotalPurchases;

        if (purchasesRemaining != null) {
          // figure out which value is less between this and user purchase logic above
          purchasesRemaining = Math.min(
            purchasesRemaining,
            purchasesUntilMaxAllowed
          );
        } else {
          // user purchases not specified, use this value only
          purchasesRemaining = purchasesUntilMaxAllowed;
        }
      }
    }
    return { purchasesRemaining, maxPurchasesReached, soldOut };
  };

  const getAdditionalOptionsGroups = () => {
    const groups = [];
    additionalOptions.map((group) => {
      if (!group.retired) {
        groups.unshift(group);
      }
    });
    return groups;
  };

  const hasActiveGroups = () => {
    const { additionalOptions } = storeItem;
    let activeGroups = additionalOptions.filter((group) => group.retired === 0);
    return activeGroups.length > 0;
  };

  const purchaseItemInfo = getRemainingPurchaseInfo(getNumItemsAlreadyInCart());

  const renderHeaderRow = () => {
    return (
      <div style={{ float: "right", width: "35px" }}>
        <IconButton
          aria-label="close"
          onClick={toggleProductInfoModal}
          style={{ position: "fixed", backgroundColor: "white" }}
        >
          <CloseIcon />
        </IconButton>
      </div>
    );
  };

  const renderProductInfo = () => {
    const { expiration, finePrint } = storeItem;
    const parsedExpiration = new Date(expiration).toLocaleDateString("en-US");

    return (
      <div>
        <div
          className={row}
          style={{ justifyContent: "center", textAlign: "-webkit-center" }}
        >
          {storeItem.imageUrl ? (
            <div
              className={productImage}
              style={{
                backgroundImage: "url(" + storeItem.imageUrl + ")",
                position: "inherit",
                marginTop: "20px",
              }}
            ></div>
          ) : (
            <div
              className={productImage}
              style={{
                position: "inherit",
                marginTop: "20px",
                backgroundImage:
                  "url(https://mobile360-assets.s3.us-east-2.amazonaws.com/no_image.png)",
              }}
            ></div>
          )}
        </div>

        <div
          className={row}
          style={{
            justifyContent: "center",
            marginTop: !storeItem.imageUrl ? "20px" : "0px",
          }}
        >
          <div>
            {" "}
            <p
              className={productName}
              style={{
                height: "auto",
                lineHeight: "auto",
                fontSize: "1.25rem",
                margin: "15px 0px",
              }}
            >
              {storeItem.title}
            </p>
            <div>
              {storeItem.price != 0 && (
                <p className={productPrice + " " + priceLabel}>
                  {priceToDollars(storeItem.price)}
                </p>
              )}
            </div>
            <p style={{ margin: "15px 0px" }}>{storeItem.description}</p>
            {storeItem.importantNote && (
              <div className={row} style={{ paddingRight: "5px" }}>
                <p style={{ fontSize: "12px" }}>
                  Note from seller: {storeItem.importantNote}
                </p>
              </div>
            )}
            <div className={row}>
              {finePrint ? (
                <p className={smallText}>{finePrint}</p>
              ) : (
                <p className={smallText}></p>
              )}
            </div>
            <div className={row}>
              {expiration ? (
                <p className={smallText}>Exp: {parsedExpiration}</p>
              ) : (
                <p className={smallText}></p>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderSelectionOptions = () => {
    const { additionalOptions } = storeItem;
    if (!additionalOptions || additionalOptions.length == 0) return null;

    const displayItems = getSortedDataToDisplay(getAdditionalOptionsGroups());

    return (
      <div>
        {displayItems.map((group) => {
          // console.dir(group);
          // if (group.retired) return null;
          const selectedOptionsMap = {};

          group.additionalOptionsItems.forEach((item) => {
            if (!item.retired) {
              selectedOptionsMap[item.id] = false;
            }
          });

          if (editItem) {
            // selectedOptionsMap[item.id] = true;
            // console.log("going to use existing selections");
            const selectedGroup = editItem.additionalOptionSelections.find(
              (element) => element.additionalOptionsGroupId === group.id
            );
            // console.dir(selectedGroup);
            if (selectedGroup) {
              selectedGroup.additionalOptionItemSelections.forEach((item) => {
                selectedOptionsMap[item.selectedAdditionalItemId] = true;
              });
            }
          }

          // console.log("printing selected options map...");
          // console.dir(selectedOptionsMap);
          return (
            <div
              style={{
                borderTop: "1px solid lightgray",
                padding: "20px 0px",
                width: "100%",
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
              }}
              key={group.id}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "275px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "5px",
                  }}
                >
                  <p style={{ fontWeight: "bold", fontSize: "18px" }}>
                    {group.title}
                  </p>
                  {!group.isOptional && (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <NewReleasesOutlinedIcon
                        color="primary"
                        fontSize="small"
                        style={{ marginRight: "5px" }}
                      />
                      <span style={{ fontSize: "10px" }}>Required</span>
                    </div>
                  )}
                </div>
                <p style={{ fontSize: "12px", marginBottom: "5px" }}>
                  {group.subtitle}
                </p>
                <p
                  style={{
                    fontSize: "10px",
                    fontStyle: "italic",
                    color: "#bbb",
                  }}
                >
                  {group.selectionInstructionsText}
                </p>
              </div>

              <AdditionalOptionsItemsGroup
                group={group}
                cartItem={cartItem}
                onCartItemChange={handleCartItemChange}
                selectedOptionsMap={selectedOptionsMap}
              />
            </div>
          );
        })}
      </div>
    );
  };

  const renderQtyInput = () => {
    // if (!cart.purchaseItems[storeItem.id]) return null;
    // const itemQty = cart.purchaseItems[storeItem.id];
    return (
      <div
        style={{
          marginTop: "0px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: hasActiveGroups() ? "115px" : "auto",
        }}
      >
        <p style={{ marginBottom: "10px" }}>Select Quantity</p>
        <QtyInput
          pid={storeItem.id}
          value={1}
          price={storeItem.price}
          cartItem={cartItem}
          onCartItemChange={handleCartItemChange}
          purchaseItemInfo={purchaseItemInfo}
        />
        {purchaseItemInfo.purchasesRemaining > 0 && (
          <div style={{ marginTop: "10px", display: "flex" }}>
            {" "}
            <p
              className={productPrice}
              style={{ padding: "0rem 1rem", fontWeight: "normal" }}
            >
              Max purchasable: {purchaseItemInfo.purchasesRemaining}
            </p>
          </div>
        )}
      </div>
    );
  };

  const renderAddToCartButton = () => {
    if (hasActiveGroups()) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "20px 0px",
          }}
        >
          <div
            style={{
              position: "fixed",
              bottom: "6.5%",
            }}
          >
            <p className={errorText}>{error}</p>
            <AddToCartButton
              color={storeColor}
              onClick={handleAddToCart}
              width={window.innerWidth}
            >
              {editItem ? "Update (" : "Add to Cart ("}
              {cartItem.subtotal != 0 ? priceToDollars(cartItem.subtotal) : ""})
            </AddToCartButton>
            <div></div>
          </div>
        </div>
      );
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          margin: "20px 0px",
        }}
      >
        <AddToCartButton color={storeColor} onClick={handleAddToCart}>
          Add to Cart ({priceToDollars(cartItem.subtotal)})
        </AddToCartButton>
      </div>
    );
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "1em",
        color: "black",
        overflowY: "auto",
        height: "100vh",
      }}
    >
      {renderHeaderRow()}
      {renderProductInfo()}
      {renderSelectionOptions()}
      {renderQtyInput()}
      {renderAddToCartButton()}
    </div>
  );
}

export default withRedux(ProductInfoModal);
